import { defineComponent as _defineComponent } from 'vue'
import BulkUpdateWrapper from '../common/BulkUpdateWrapper.vue'
import PrioritySelector from '../tickets/PrioritySelector.vue'
import { computed, ref, onMounted } from 'vue'
import { priorities } from '@/utils/constants'
import { JobJson } from '@/models/types/job-json'
import { BulkUpdateResponse } from '@/models/types/bulk-update-response'
import { updatePriority } from '@/api/jobs'


export default /*#__PURE__*/_defineComponent({
  __name: 'BulkUpdatePriorityForm',
  props: {
    buttonLabel: null,
    selectedJobs: null
  },
  emits: ["dismiss", "updated"],
  setup(__props: any, { emit: emits }: { emit: ({
  (e: 'dismiss')
  (e: 'updated', { message, updatedJobs }: BulkUpdateResponse)
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  buttonLabel: string
  selectedJobs: JobJson[]
}




const error = ref(false)
const saving = ref(false)
const priority = ref<number | undefined>()
let initialPriority: number | undefined

onMounted(() => {
  const selectedPriorities: Set<string> = new Set(
    props.selectedJobs.map((job) => job.priority)
  )
  if (selectedPriorities.size === 1) {
    const selectedPriority = [...selectedPriorities][0]
    initialPriority = priorities.find(
      (priority) => priority.name === selectedPriority
    )?.id
  }
  priority.value = initialPriority
})

const hasChanges = computed<boolean>(() => {
  return priority.value !== initialPriority
})
const showHint = computed<boolean>(() => {
  return !priority.value && initialPriority === undefined
})

const setPriority = (newPriority: number) => (priority.value = newPriority)

const clearSnackbar = () => (error.value = false)
const dismiss = () => emits('dismiss')

const save = async () => {
  if (priority.value === undefined) {
    error.value = true
    return
  }

  saving.value = true
  try {
    await updatePriority(
      props.selectedJobs.map((job) => job.number),
      priority.value
    )
    const newPriorityName = priorities.find(
      (p) => p.id === priority.value
    )?.name
    const updatedJobs: JobJson[] = props.selectedJobs.map(({ ...job }) =>
      Object.assign(job, { priority: newPriorityName })
    )
    emits('updated', { message: 'Priority updated', updatedJobs })
  } catch (err) {
    error.value = true
  } finally {
    saving.value = false
  }
}

return { __sfc: true,emits, props, error, saving, priority, initialPriority, hasChanges, showHint, setPriority, clearSnackbar, dismiss, save, BulkUpdateWrapper, PrioritySelector }
}

})